// import { InputSelect } from "#common/componentes/Inputs"
import { MasterDialog } from "#common/Dialog/Dialog"
import { UseContextsCompetence } from "#competence/contexts/ContextsCompetence"
import { CompetenceDelete } from "#competence/services/Api"
import { useApiSend } from "#hooks/useApiSend"
import { Stack, Typography } from "@mui/material"
import { Fragment, useMemo, useState } from "react"

export default function CompetenceInfoDelete({ open, setOpen }) {
	const { refresh, competence } = UseContextsCompetence()
	const [disabled, setDisabled] = useState(false)
	const [disabledCancelar, setDisabledCancelar] = useState(false)

	const success = () => {
		refresh()
		setOpen(false)
	}

	const end = () => {
		setDisabled(false)
		setDisabledCancelar(false)
	}
	const { fetch } = useApiSend(CompetenceDelete, { success, end })

	const buttons = useMemo(() => {
		return [
			{
				label: "Cancelar",
				onClick: () => {
					setOpen(false)
				},
				disabled: disabledCancelar,
			},
			{
				label: "Confirmar",
				onClick: () => {
					setDisabled(true)
					setDisabledCancelar(true)
					fetch(competence?.id)
				},
				disabled,
			},
		]
	}, [disabled, disabledCancelar, fetch, competence?.id, setOpen])

	return (
		<Fragment>
			<MasterDialog
				{...{
					open,
					setOpen,
					title: `Desactivar Competencia `,
					buttons,
				}}
				maxWidth="sm"
			>
				<Stack spacing={2} sx={{ width: "100%" }}>
					<Typography variant="h5" textAlign="center">
						¿Estás seguro de que deseas desactivar la competencia{" "}
						<strong>"{competence?.name}"</strong>?
					</Typography>
					<Typography variant="h6" textAlign="center">
						<strong>Esta acción no se puede deshacer.</strong>
					</Typography>
				</Stack>
			</MasterDialog>
		</Fragment>
	)
}
